import type {CheckoutBookingRedeemerService} from "@/scopes/checkout/domain/types";
import {produce} from "immer";

interface BookingRedeemerServicePayload {
  value: string | null;
}

export function updateBookingRedeemerService(payload: BookingRedeemerServicePayload) {
  return produce((service: CheckoutBookingRedeemerService) => {
    service.selectedValue = payload.value;
  });
}
